import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {ReportMetadata} from '../models/report.model';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export class RequiredreportscheduleService {
  endpoint = environment.apiEndpoint + '/ReportSchedule/';
  requiredreportScheduleData:ReportMetadata[];
  constructor(private http: HttpClient) { }
  getReportSchedule(): Observable<any> {
    //console.log('in RequiredReportDashboardService');
    return this.http.get(this.endpoint + 'GetPostAuthorReportSchedules');
  }

  getReportScheduleById(Id: any): Observable<any> {
      //console.log('In GetReportScheduleByID with Id:' + Id);
      return this.http.get(this.endpoint + 'GetReportScheduleById?id=' + Id);
  }
  getReportbasedonyear(reportyear: any): Observable<any>{
    //console.log('in GetReportBasedOnYear with year:' + reportyear);
    return this.http.get(this.endpoint + 'GetReportbasedOnYear?reportyear=' + reportyear);
  }

}
